import React from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {
    ActionDescriptorsPopulation,
    ActionPopulationTypesAdd,
    ActionPopulationTypesDelete,
    ActionPopulationTypesEdit
} from "../../../parts/actions";
import ColumnResizer from "react-column-resizer";
import ToolButtons from "../../../parts/ToolButtons";
import Search from "../../../parts/Search";
import api from "../../../api";
import Storege from "../../../storage/storage";
import PopulationTypePopup from "./PopulationTypePopup";
import RemoveButton from "../../../parts/removeBtn";
import CommonTab from "../../../parts/CommonTabClass";
import EditBtn from "../../../parts/EditBtn";

class PopulationDescriptorComponent extends CommonTab {

    orderFields = {
        "Place Population Type Name": "placepopulationtypename",
        "Place Population Type Name Eng": "placepopulationtypenameeng"
    };

    state = {
        population: {},
        popup: false,
        popupType: undefined
    };

    constructor(props) {
        super(props);
        this.state.population = props.population;
    }

    changePopupType = (actionType) => {
        this.setState({
            popupType: actionType
        })
    };

    changePopupState = () => {
        let currentPopupState = this.state.popup;
        this.setState(
            {
                popup: !currentPopupState
            }
        )
    };

    getId(pathName) {
        let path = (pathName).split('/');
        let id = path[path.length - 1];
        return id;
    }

    addContentType = (object) => {
        ActionPopulationTypesAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD PLACE POPULATION TYPE',
                item: data
            });
            this.changePopupState();
            this.props.history.push('population_types/' + data.placepopulationtypeid);
        });
    };

    editContentType = (object) => {
        ActionPopulationTypesEdit(object.placepopulationtypeid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE PLACE POPULATION TYPE',
                item: data,
                id: data.placepopulationtypeid
            });
            this.changePopupState();
            this.props.history.push(data.placepopulationtypeid);
        });
    };

    changeState = (name, e, id) => {
        let temp = this.props.population;
        temp.forEach(function (item) {
            if (item.placepopulationtypeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            population: Object.assign({}, temp)
        });
    };

    search = (value) => {
        if (value.length) {
            let filteredArray = this.props.population.filter(item => {
                return item.placepopulationtypename.toLowerCase().indexOf(value.toLowerCase()) != -1 || item.placepopulationtypenameeng.toLowerCase().indexOf(value.toLowerCase()) != -1;
            });
            this.setState({
                filtered: true,
                filteredItems: filteredArray
            });
        } else {
            this.setState({
                filtered: false
            });
        }
    };

    render() {
        if (!this.props.population.length) {
            ActionDescriptorsPopulation();
        }
        let {population} = this.props
        let {filtered, filteredItems} = this.state;
        let list = filtered ? filteredItems : population;
        if (!list) {
            return (
                <div className="overlay-loader">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }

        this.sortResults(list);

        return (
            <div>
                <div className="inline-toolbuttons">
                    <h3>Place Population Types:</h3>
                    <div className={'tool-bar'}>
                        <ToolButtons
                            actionType={this.changePopupType}
                            popupChange={this.changePopupState}
                            id={this.state.currentItemIndex}
                        />
                        <Search
                            change={this.search}
                        />
                    </div>
                </div>
                <table className='table table-striped'>
                    <thead>
                    {this.orderPanel()}
                    </thead>
                    <tbody>
                    {(list ? list : []).map((item, index) => {
                        return (
                            <tr key={index} onClick={
                                e => {
                                    e.preventDefault();
                                    this.setState({
                                        rowIndex: index,
                                        currentItemIndex: item.placepopulationtypeid
                                    });
                                }
                            } className={this.state.rowIndex == index ? 'active' : ''}>
                                <td className={'flex-row'}>
                                    <RemoveButton
                                        action={ActionPopulationTypesDelete}
                                        id={item.placepopulationtypeid}
                                        descriptor={'REMOVE PLACE POPULATION TYPE'}
                                    />
                                    <EditBtn
                                        actionType={this.changePopupType}
                                        popupChange={this.changePopupState}
                                        change={this.setCurrentIndex}
                                        id={item.placepopulationtypeid}
                                    />
                                </td>
                                <td>
                                    <Link
                                        to={api.getRoute('descriptors/place_types/population_types/' + item.placepopulationtypeid)}>
                                       {item.placepopulationtypename}</Link>
                                </td>
                                <ColumnResizer className="columnResizer" minWidth={5}/>
                                <td>
                                    <Link
                                        to={api.getRoute('descriptors/place_types/population_types/' + item.placepopulationtypeid)}>
                                        {item.placepopulationtypenameeng}</Link>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
                {this.state.popup ? <PopulationTypePopup
                    close={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        population: state.populationType
    }
};
const DescriptorPopulation = connect(mapStateToProps)(PopulationDescriptorComponent);

export default DescriptorPopulation;